import { createStyles } from "@mantine/core";

const useStyles = createStyles(() => ({
  content: {
    display: "flex",
    minHeight: "100vh",
    maxHeight: "fit-content",
    width: "100%",
    flexDirection: "column",
    overflowX: "auto",
    backgroundColor: "#F5F5F5",
  },
  toolbarCard: {
    marginTop: 24,
    background: "#fff",
    border: "1px solid #E5E5E5",
    borderRadius: 12,
    boxShadow: "0 1px 2px rgba(16,24,40,.04)",
    padding: "11px 12px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 12,
    flexWrap: "wrap",
    "@media (max-width: 600px)": {
      flexDirection: "column",
      alignItems: "stretch",
    },
  },
  segmented: {
    display: "flex",
    background: "#fff",
    border: "1px solid #E5E5E5",
    borderRadius: 10,
    padding: 4,
    gap: 2,
  },
  segItem: {
    padding: "6px 14px",
    borderRadius: 7,
    fontSize: 13,
    fontWeight: 600,
    fontFamily: "Inter",
    color: "#667085",
    background: "transparent",
    border: "none",
    cursor: "pointer",
    whiteSpace: "nowrap",
  },
  segItemOn: {
    background: "#53389E",
    color: "#fff",
  },
  btnAdd: {
    height: 40,
    padding: "0 18px",
    borderRadius: 8,
    background: "#FFAF4A",
    color: "#171717",
    fontWeight: 700,
    fontSize: 13.5,
    fontFamily: "Inter",
    border: "1px solid #FFAF4A",
    display: "inline-flex",
    alignItems: "center",
    gap: 8,
    "&:hover": { background: "#F09E33" },
  },
  iconBtnSquare: {
    width: 40,
    height: 40,
    borderRadius: 10,
    border: "1px solid #E5E5E5",
    background: "#fff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#262626",
    "&:hover": { background: "#FAFAFA" },
  },
  tableWrap: {
    marginTop: 16,
    background: "#fff",
    border: "1px solid #E5E5E5",
    borderRadius: 12,
    boxShadow: "0 1px 2px rgba(16,24,40,.04)",
    overflow: "hidden",
  },
  cardToolbar: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    padding: "12px 16px",
    borderBottom: "1px solid #F3F4F6",
    flexWrap: "wrap",
  },
  search: {
    flex: 1,
    minWidth: 200,
    display: "flex",
    alignItems: "center",
    gap: 8,
    height: 36,
    border: "1px solid #E5E5E5",
    borderRadius: 8,
    padding: "0 12px",
    color: "#9CA3AF",
    "& input": {
      border: "none",
      outline: "none",
      flex: 1,
      background: "transparent",
      fontSize: 13.5,
      fontFamily: "Inter",
      color: "#171717",
    },
  },
  tableRoot: {
    width: "100%",
    "& thead th": {
      background: "#F2F2F2",
      fontFamily: "Inter",
      fontSize: 12.5,
      fontWeight: 600,
      color: "#171717",
      textAlign: "left",
      padding: "10px 16px",
      whiteSpace: "nowrap",
    },
    "& tbody td": {
      fontFamily: "Inter",
      fontSize: 14,
      color: "#171717",
      padding: "12px 16px",
      borderTop: "1px solid #F3F4F6",
      whiteSpace: "nowrap",
    },
    "& tbody tr:hover td": {
      background: "#FAFAFA",
    },
  },
  row: {
    cursor: "pointer",
  },
  tdMain: {
    fontWeight: 600,
    color: "#171717",
  },
  num: { fontVariantNumeric: "tabular-nums" },
  mutedCell: {
    color: "#9CA3AF",
  },
  pill: {
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    textTransform: "uppercase",
    fontSize: 11,
    fontWeight: 700,
    letterSpacing: ".05em",
    padding: "4px 12px",
    borderRadius: 999,
    border: "1px solid",
    fontFamily: "Inter",
  },
  pillOgiso: {
    background: "#EFF6FF",
    color: "#1D4ED8",
    borderColor: "#BFDBFE",
  },
  pillExternal: {
    background: "#F3F0FB",
    color: "#43307E",
    borderColor: "#DDD6FE",
  },
  pillPending: {
    background: "#FFF6E9",
    color: "#B45309",
    borderColor: "#FFE0B0",
  },
  pillDeleted: {
    background: "#FEF2F2",
    color: "#B91C1C",
    borderColor: "#FECACA",
  },
  ehrChip: {
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    fontSize: 12,
    fontWeight: 600,
    fontFamily: "Inter",
    color: "#262626",
    background: "#F4F4F5",
    border: "1px solid #E5E5E5",
    borderRadius: 999,
    padding: "3px 10px",
    whiteSpace: "nowrap",
  },
  kebab: {
    width: 32,
    height: 32,
    borderRadius: 8,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#667085",
    "&:hover": { background: "#F4F4F5", color: "#171717" },
  },
  rowMenuDropdown: {
    borderRadius: 10,
    border: "1px solid #E5E5E5",
    boxShadow: "0 12px 32px rgba(15,23,42,.16)",
    padding: 6,
  },
  rowMenuItem: {
    borderRadius: 7,
    fontSize: 13,
    fontWeight: 500,
    fontFamily: "Inter",
    padding: "9px 12px",
  },
  cardPagination: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "12px 16px",
    borderTop: "1px solid #F3F4F6",
    flexWrap: "wrap",
    gap: 10,
  },
  pagInfo: {
    fontSize: 13,
    color: "#667085",
    fontFamily: "Inter",
  },
  // In-table "nothing matched" row — keeps the toolbar (and its search box)
  // on screen instead of swapping the whole card for emptyProviderBox.
  emptyCell: {
    textAlign: "center",
    color: "#737373",
    fontSize: 14,
    fontFamily: "Inter",
    padding: "44px 16px",
  },
  emptyProviderBox: {
    minHeight: 442,
    padding: 41,
    margin: "24px auto",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    borderRadius: 12,
    border: "1px solid #E5E5E5",
    background: "#fff",
    maxWidth: 761,
    width: "100%",
  },
  iconBox: {
    height: 158,
    width: 158,
    borderRadius: "50%",
    borderTop: "1px solid #D4D4D4",
    background:
      "linear-gradient(180deg, #F1F1F1 0%, rgba(255, 255, 255, 0.00) 81.19%)",
    "& svg": {
      height: 70,
      width: 70,
    },
  },
}));

export default useStyles;
